import React, { Component } from "react";

class NotFound extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="container">
        <div className="col-md-12 text-center">
          <div style={{ marginTop: "425px" }}>
            <h1 style={{ fontSize: "45px" }}>Page not found!</h1>
            <button
              className="btn btn-sm btn-link"
              onClick={() => this.props.history.push("/dashboard")}
            >
              Back to Dashboard
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default NotFound;
